import React from "react";
import SportsPromotionsApp from "./App";
import { Helmet } from "react-helmet";
import "./styles.css";

/**
 * Render react app with redux store
 */
interface IProps {
  selectedCountry: string;
  isDesktopResolution: boolean;
}

const SportsPromotions: React.FC<IProps> = ({
  selectedCountry,
  isDesktopResolution,
}) => {
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sports Promotions</title>
      </Helmet>
      <SportsPromotionsApp
        selectedCountry={selectedCountry}
        isDesktopResolution={isDesktopResolution}
      />
    </React.Fragment>
  );
};

export default SportsPromotions;
